// extracted by mini-css-extract-plugin
module.exports = {"header":"accountSimplifiedHeader_header__3Pul1"};